import axios from "axios";
import { environment } from "@/data/environment";

const actions = {
    async getDianFormats({ commit, state }, { idCompany, token }) {
        try {
            const { data } = await axios.get(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/settings`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;

        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async getConfiguration({ commit, state }, { idCompany, token, year, format }) {
        try {
            const data = await axios.get(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/years/${year}/formats/${format}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async saveConfigImport({ commit }, { idCompany, token, dataCredentials, dataTable, dataFilter }) {
        try {
            const params = {
                topAmount: dataCredentials.topeA,
                topAmount2: dataCredentials.topeB,
                topLiabilities: dataCredentials.topeLimite,
                appliesGroupingByLackData: dataCredentials.appliesGroupingByLackData,
                conceptsCfg: dataTable,
            };

            const { data } = await axios.post(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/years/${dataFilter.year}/formats/${dataFilter.format}`,
                params,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async saveConfigTaxes({ commit }, { idCompany, token, hTaxes, selectedTaxes }) {
        try {
            let params = hTaxes.map(tax => ({
                id: tax.id,
                isIvaMayorValorCosto: selectedTaxes.includes(tax.id),
            }));

            const { data } = await axios.put(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/htaxes`,
                params,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    async copyFormatsYear({ commit }, { idCompany, token, dataCopy }) {
        try {
            const payload = {
                targetYear: dataCopy.to,
                formats: dataCopy.formats.map(id => ({
                    id
                }))
            };

            const { data } = await axios.post(
                `${environment.HIOPOSWEBSERVICES}/api/exogena/companies/${idCompany}/years/${dataCopy.from}/copy-config`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            return data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
};

const mutations = {
    //
};

const state = {
    //
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};